import { useState } from 'react';
import { getCsrfToken } from '../utils/auth';

export function SimpleEditableVesselName({ devkit, setDevices }) {
	const [isEditing, setIsEditing] = useState(false);
	const [value, setValue] = useState(devkit.vessel_name || '');

	// Sanitize input to prevent XSS and ensure safety
	const sanitizeInput = (input) => {
		return input
			.replace(/[<>]/g, '') // Remove angle brackets to prevent HTML injection
			.replace(/[^\w\s\-_.]/g, ''); // Allow alphanumeric, spaces, hyphens, underscores, and dots
	};

	const handleInputChange = (e) => {
		const rawValue = e.target.value;

		// Limit to 100 characters
		if (rawValue.length > 100) {
			return;
		}

		// Sanitize the input
		const sanitizedValue = sanitizeInput(rawValue);
		setValue(sanitizedValue);
	};

	const handleBlur = async () => {
		const trimmedValue = value.trim();
		if (trimmedValue === devkit.vessel_name) {
			setIsEditing(false);
			return;
		}

		try {
			const res = await fetch(`/api/update-vessel`, {
				method: 'POST',
				credentials: 'include', // send JWT cookies
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': getCsrfToken()
				},
				body: JSON.stringify({
					devkit_id: devkit.devkit_id,
					vessel_name: trimmedValue,
				}),
			});

			if (!res.ok) {
				const err = await res.json().catch(() => ({}));
				throw new Error(err.error || 'Update failed');
			}

			const updateResult = await res.json();
			console.log('updateResult:', updateResult);

			// Optionally update local state immediately:
			setDevices((d) =>
				d.map((dk) =>
					dk.devkit_id === devkit.name
						? { ...dk, vessel_name: trimmedValue }
						: dk
				)
			);
		} catch (error) {
			console.error('Failed to save vessel name:', error);
			// revert the edit
			setValue(devkit.vessel_name || '');
		} finally {
			setIsEditing(false);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.target.blur();
		} else if (e.key === 'Escape') {
			setValue(devkit.vessel_name || '');
			setIsEditing(false);
		}
	};

	return (
	<div className='font-sans text-xs font-semibold text-right min-w-0'>
	  <p className='text-xs font-medium text-gray-500 uppercase tracking-wide'>
		Vessel Name
	  </p>
	  {!isEditing ? (
		<p
		  className='text-sm text-gray-900 font-medium mt-1 cursor-pointer hover:text-blue-600 transition-colors select-none'
		  onClick={() => setIsEditing(true)}
		  title='Click to edit'
		>
		  {value || (
			<span className='text-gray-400 italic'>Click to add</span>
		  )}
		</p>
	  ) : (
				<div className='relative'>
					<input
						type='text'
						value={value}
						onChange={handleInputChange}
						onBlur={handleBlur}
						onKeyDown={handleKeyDown}
						className='text-gray-700 font-medium bg-white border border-gray-300 rounded px-2 py-1 text-right focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[200px]'
						maxLength={100}
						autoFocus
						placeholder='Enter vessel name'
					/>
					<div className='absolute -bottom-15 right-0 text-xs text-gray-400'>
						{value.length}/100
					</div>
				</div>
			)}
		</div>
	);
}
